module.exports = __webpack_public_path__ + "static/media/invite.7cbcda75.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity_100/invite.png
// module id = 1161
// module chunks = 0